export default [{
  name: 'cdc',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaDadosContato: {},
        PessoaBanco: {},
        PessoaEndereco: {}
      },
      Parcela: {},
    },
    dadosIniciais: {}
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    dadosIniciais (state) {
      return state.dadosIniciais
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaBanco: {},
          PessoaDadosContato: {},
          PessoaEndereco: {}
        },
        Parcela: {},
        PessoaDadosContato: {},
        Split: {},
      }
      commit('model', data)
    },
    beforeEach ({ getters, commit }, { to, from, next }) {
      if (to.fullPath.includes('preview')) {
        localStorage.clear()
        next()
      }
      switch (to.fullPath) {
        case '/':
          if (localStorage.ambiente) { next({ path: '/partner/' + localStorage.ambiente }) }
          break;
      }
    }
  },
  logoutFunctions: {
    afterClear (state) {
      location.href = '/partner/' + state.empresa.ambiente
    },
  }
}]
